import React, { createContext, useState, useContext, useEffect } from 'react';

const ShoppingContext = createContext();

export function ShoppingProvider({ children }) {
  const [selectedImages, setSelectedImages] = useState([]);
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('cartItems');
    return saved ? JSON.parse(saved) : [];
  });
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  const toggleImageSelection = (image) => {
    setSelectedImages(prev => {
      const isSelected = prev.some(img => img.url === image.url);
      if (isSelected) {
        return prev.filter(img => img.url !== image.url);
      } else {
        return [...prev, image];
      }
    });
  };

  const addToCart = (image) => {
    setCartItems(prev => {
      if (!prev.some(item => item.url === image.url)) {
        return [...prev, { ...image, selectedSize: null, quantity: 1 }];
      }
      return prev;
    });
    setIsCartOpen(true);
  };

  const removeFromCart = (item) => {
    setCartItems(prev => prev.filter(i => i.url !== item.url));
  };

  const updateCartItemSize = (item, size) => {
    setCartItems(prev => 
      prev.map(i => 
        i.url === item.url 
          ? { ...i, selectedSize: size }
          : i
      )
    );
  };

  const updateCartItemQuantity = (item, quantity) => {
    setCartItems(prev => 
      prev.map(i => 
        i.url === item.url 
          ? { ...i, quantity: Math.max(1, Math.min(10, parseInt(quantity) || 1)) }
          : i
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const clearSelected = () => {
    setSelectedImages([]);
  };

  const value = {
    selectedImages,
    cartItems,
    isCartOpen,
    toggleImageSelection,
    addToCart,
    removeFromCart,
    updateCartItemSize,
    updateCartItemQuantity,
    clearCart,
    clearSelected,
    setSelectedImages,
    setCartItems,
    setIsCartOpen
  };

  return (
    <ShoppingContext.Provider value={value}>
      {children}
    </ShoppingContext.Provider>
  );
}

export function useShopping() {
  return useContext(ShoppingContext);
} 